import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d0b5512"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "file-list"
}
const _hoisted_2 = {
  key: 0,
  class: "empty"
}
const _hoisted_3 = ["onClick"]

import DefaultIcon from '@/components/atomic/DefaultIcon';
import { ref, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileList',
  props: {
	workspace: Object,
	fileTree: Object,
	level: Number,
	path: String
},
  setup(__props) {

const props = __props;


const showFiles = ref(false);

onMounted(() => {
	if (props.level === 0 || props.level === 1) {
		showFiles.value = true;
	}
})

const sortedFiles = () => {
	return [...props.fileTree.children].sort((e1, e2) => {
		if (e1.type === 'FOLDER' && e2.type === 'FILE') {
			return -1;
		} else if (e1.type === 'FOLDER' && e2.type === 'FOLDER' && 
			e1.name.localeCompare(e2.name) < 0 ) {
			return -1;
		} else if (e1.type === 'FILE' && e2.type === 'FOLDER') {
			return 1;
		} else if (e1.type === 'FILE' && e2.type === 'FILE' && 
			e1.name.localeCompare(e2.name) < 0) {
			return -1;
		}
		return 0;
	});
};

return (_ctx: any,_cache: any) => {
  const _component_FileList = _resolveComponent("FileList", true)!

  return (__props.workspace)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        _createElementVNode("li", {
          class: "folder",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showFiles.value = !showFiles.value))
        }, [
          _createElementVNode("span", {
            style: _normalizeStyle({ paddingLeft: `${__props.level * 6}px` })
          }, [
            (showFiles.value)
              ? (_openBlock(), _createBlock(_unref(DefaultIcon), {
                  key: 0,
                  class: "fd-icon",
                  icon: __props.fileTree.name ? 'codicon-folder-opened' : 'codicon-root-folder-opened'
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            (!showFiles.value)
              ? (_openBlock(), _createBlock(_unref(DefaultIcon), {
                  key: 1,
                  class: "fd-icon",
                  icon: __props.fileTree.name ? 'codicon-folder' : 'codicon-root-folder'
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(__props.fileTree.name ? __props.fileTree.name : '/'), 1)
          ], 4),
          (showFiles.value)
            ? (_openBlock(), _createBlock(_unref(DefaultIcon), {
                key: 0,
                class: "menu-icon",
                icon: "codicon-chevron-up"
              }))
            : _createCommentVNode("", true),
          (!showFiles.value)
            ? (_openBlock(), _createBlock(_unref(DefaultIcon), {
                key: 1,
                class: "menu-icon",
                icon: "codicon-chevron-down"
              }))
            : _createCommentVNode("", true),
          (__props.fileTree.name && __props.fileTree.children.length === 0)
            ? (_openBlock(), _createBlock(_unref(DefaultIcon), {
                key: 2,
                class: "menu-icon",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.workspace.deleteFolder(`${__props.path ? __props.path : ''}`, $event))),
                icon: "codicon-trash"
              }))
            : _createCommentVNode("", true)
        ]),
        (showFiles.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (!__props.fileTree.children.length)
                ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ paddingLeft: `${__props.level * 10}px` })
                    }, "Empty folder", 4)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedFiles(), (editor) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: editor.id
                }, [
                  (editor.type == 'FILE')
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: _normalizeClass(["file", { 
					active: editor.id == __props.workspace.getCurrentEditorId() && __props.workspace.isEditorActive(editor.id) }]),
                        onClick: ($event: any) => (__props.workspace.selectEditor(editor.id, $event))
                      }, [
                        _createElementVNode("span", {
                          style: _normalizeStyle({ paddingLeft: `${__props.level * 10}px` })
                        }, _toDisplayString(editor.name), 5),
                        _createVNode(_unref(DefaultIcon), {
                          class: "menu-icon",
                          onClick: ($event: any) => (__props.workspace.deleteEditor(editor.id, $event)),
                          icon: "codicon-trash"
                        }, null, 8, ["onClick"])
                      ], 10, _hoisted_3))
                    : _createCommentVNode("", true),
                  (editor.type=='FOLDER')
                    ? (_openBlock(), _createBlock(_component_FileList, {
                        key: 1,
                        level: __props.level + 1,
                        path: `${__props.path ? __props.path : ''}/${editor.name}`,
                        workspace: __props.workspace,
                        fileTree: editor
                      }, null, 8, ["level", "path", "workspace", "fileTree"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})